module.exports = __webpack_public_path__ + "static/src/content/logos/itunes.e3edbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/logos/itunes.png
// module id = igmT
// module chunks = 1